<template>
  <validation-observer ref="form" tag="div">
    <v-card color="grey lighten-1" class="pt-6" flat rounded="xl">
      <v-container class="px-6">
        <v-row>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="Ad"
              rules="required|min:3"
            >
              <v-text-field
                v-model="data.name"
                label="Ad"
                filled
                rounded
                placeholder="Adınızı yazın"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="Soyad"
              rules="required|min:3"
            >
              <v-text-field
                v-model="data.surname"
                label="Soyad"
                filled
                rounded
                placeholder="Soyadınızı yazın"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="Telefon"
              rules="required|length:14"
            >
              <v-text-field
                v-model="data.tel"
                filled
                rounded
                v-maska="'0### ### ## ##'"
                label="Telefon Numarası"
                placeholder="Lütfen telefon numaranızı girin"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="E-Posta"
              rules="email"
            >
              <v-text-field
                v-model="data.email"
                filled
                rounded
                label="E-Posta Adresi"
                placeholder="E-Posta adresinizi girin"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row align="center" class="pb-6">
          <v-col cols="6" class="text-right">Satış Kanalı</v-col>
          <v-col cols="6">
            <v-radio-group
              hide-details=""
              class="pa-0 ma-0"
              v-model="data.referral"
              row
            >
              <v-radio label="Çağrı Merkezi" value="callCenter"></v-radio>
              <v-radio label="Ticimax" value="ticimax"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-container class="px-6">
      <v-row align="center" class="my-9">
        <v-col cols="12" md="6"> </v-col>
        <v-col cols="12" md="6">
          <v-btn
            color="secondary"
            class="text-capitalize"
            depressed
            rounded
            x-large
            block
            @click="continueStep()"
          >
            Devam Et
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </validation-observer>
</template>

<script>
import { useRouter } from "@core/utils";
import { useCallCenterStore } from "@/stores/callCenter";

import { onMounted, ref } from "@vue/composition-api";

export default {
  setup() {
    const { route } = useRouter();
    const callCenterStore = useCallCenterStore();

    const form = ref(null);

    const data = ref({
      name: "",
      surname: "",
      tel: "",
      email: "",
      referral: "callCenter",
    });

    onMounted(() => {
      if (route.value.params.item) {
        data.value = callCenterStore.data.customer;
      }
    });

    const continueStep = async () => {
      const isValid = await form.value.validate();

      if (!isValid) {
        return;
      }

      callCenterStore.data.customer = data;
      callCenterStore.increment();
    };

    return {
      form,
      data,
      continueStep,
    };
  },
};
</script>

<style>
</style>
